import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SiteHeader } from '@/components/landing/SiteHeader'
import { SiteFooter } from '@/components/landing/SiteFooter'

/**
 * The chrome every marketing page sits inside: the suite masthead above, the
 * suite footer below, and the page itself in between.
 *
 * <p>Holding it in one layout rather than repeating it per page is what makes
 * the header and footer identical everywhere — which is the whole point of
 * them.
 */
export function SiteLayout() {
  const { pathname } = useLocation()

  // Without this the browser keeps the previous page's scroll offset, so
  // following a nav link can land halfway down the new page.
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className="flex min-h-full flex-col bg-brand-page font-sans text-brand-body antialiased">
      <SiteHeader />
      {/* Grows so a short page still pushes the footer to the bottom of the
          window rather than leaving it floating mid-screen. */}
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  )
}
